/**
 * Keeps the header's CheckInOut widget and the CheckInGate modal in sync.
 *
 * They're two independent components (CheckInGate is mounted once at the
 * router root, CheckInOut lives inside Header and remounts per route) that
 * each keep their own local copy of the signed-in admin's attendance status.
 * Without this, checking in from one doesn't update the other until the next
 * full page load. Whichever one calls the API broadcasts the fresh status
 * payload here; the other just applies it, no extra fetch needed.
 */
const ATTENDANCE_EVENT = 'admin-attendance-updated';

export const broadcastAttendance = (data) => {
    if (!data) return;
    window.dispatchEvent(new CustomEvent(ATTENDANCE_EVENT, { detail: data }));
};

/** Returns the cleanup function — call it from a useEffect's return. */
export const onAttendanceUpdate = (handler) => {
    const listener = (event) => handler(event.detail);
    window.addEventListener(ATTENDANCE_EVENT, listener);
    return () => window.removeEventListener(ATTENDANCE_EVENT, listener);
};
